GUARDSFactory.$inject = ["$q", "AuthenticationNew", "UserService"];export function GUARDSFactory($q, AuthenticationNew, UserService) {
  "ngInject";

  return {
    isAuthorized: function isAuthorized() {var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return AuthenticationNew.isAuthenticatedAsync(reload);
    },

    isCheckedin: function isCheckedin() {
      return UserService.getCurrentUser().
      then(function () {
        return UserService.currentDayIndex < 7;
      });
    } };


}